
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { AccountApiClient, TreeNode } from '../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'CreateTemplateModal',
  components: {
    vSelect,
  },
})
export default class CreateTemplateModal extends Vue {
  name: string = '';
  shared: boolean = false;
  sharedWithAccounts: number[] = [];

  private readonly accountApi = initClient(AccountApiClient);
  accountsAvailableToShareWith: TreeNode[] = [];

  get removeWhenPivotCompletelyInVue(): any {
    return { opacity: 1 };
  }

  get removeWhenPivotCompletelyInVue2(): any {
    return { transform: 'unset' };
  }

  async mounted(): Promise<void> {
    await this.reload();
  }

  async reload(): Promise<void> {
    const accountSelect = await this.accountApi.getAccountSelect(undefined);
    const y = accountSelect.parentList?.find(e => e.dbId === accountSelect.selectedItem);
    const flatten = (nodes: TreeNode[] | undefined) => (nodes ?? []).map(e => [e, ...flatten(e.nodes)]).reduce((l, r) => l.concat(r), []);
    this.accountsAvailableToShareWith = flatten(y?.nodes);
  }

  openModal(): void {
    this.name = '';
    this.shared = false;
    this.sharedWithAccounts = [];
    $(this.$refs.modal!).modal('show');
  }

  closeModal(): void {
    $(this.$refs.modal!).modal('hide');
  }

  createTemplate(): void {
    this.$emit('created', { name: this.name, shared: this.shared, sharedWithAccounts: this.sharedWithAccounts });
  }
}
